import React from 'react';
import { AUTOFILL_IGNORE_PROPS } from '../../lib/autofill';

export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  const { className = '', ...rest } = props;
  return (
    <input
      {...AUTOFILL_IGNORE_PROPS}
      className={`block w-full rounded-lg bg-bg-raised px-3.5 py-2.5 text-sm text-content-primary placeholder:text-content-placeholder shadow-sm ring-0 outline-none transition-shadow duration-200 focus:shadow-md focus:ring-2 focus:ring-blueberry-200/50 ${className}`}
      {...rest}
    />
  );
}
